import React from 'react';
import PropTypes from 'prop-types';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import { WhiteLogo } from '@womcorp/wom-miwom-ui-kit/dist/@theme/assets/svg/miscellaneous';
import {
  AdsBackgroundStyled as AdsBackground,
  ImageStyled as Image,
  DescriptionStyled as Description,
  ProgressBarStyled as ProgressBar,
} from './styles/SplashScreenAdsStyled';

const SplashScreenAds = ({ ads }) => {
  const { image, description, duration } = ads;
  return (
    <AdsBackground>
      <WhiteLogo />
      <Image
        alt={image.title}
        src={image.url}
        width={image.width}
        height={image.height}
      />
      <Description>{documentToReactComponents(description.json)}</Description>
      <ProgressBar lapse={duration * 1000} />
    </AdsBackground>
  );
};

SplashScreenAds.propTypes = {
  ads: PropTypes.shape({
    description: PropTypes.shape({
      json: PropTypes.shape({}),
    }),
    duration: PropTypes.number,
    image: PropTypes.shape({
      title: PropTypes.string,
      url: PropTypes.string,
      width: PropTypes.number,
      height: PropTypes.number,
    }),
  }).isRequired,
};

export default SplashScreenAds;
